import {Component, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {DateRangeDto} from '../../shared/dto/DateRangeDto';
import {MatTableDataSource} from '@angular/material/table';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {SmsService} from '../../shared/service/sms.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {SmsModel} from '../../model/smsModel';
import {SearchRequestModel} from '../../shared/dto/search-request.model';
import swal from 'sweetalert2';
import {smsSearchDTO} from '../../shared/dto/smsSearchDTO';

@Component({
  selector: 'app-sms-report',
  templateUrl: './sms-report.component.html',
  styleUrls: ['./sms-report.component.scss']
})
export class SmsReportComponent implements OnInit {
  public requestForm: FormGroup;
  dataSource: MatTableDataSource<any>;
  public dto: SmsModel[] = [];
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;
  displayedColumns: string[] = ['phoneNumber', 'message', 'createdTime', 'status'];

  constructor(private spinnerService: NgxUiLoaderService, private smsService: SmsService) {
  }

  ngOnInit() {
    this.requestForm = new FormGroup({
      dateTimeRange: new FormControl(null),
      mobileNo: new FormControl(null)
    });
    this.loadAllRecords();
  }

  loadAllRecords() {
    this.smsService.getAllRecords().subscribe(
      (data: SmsModel[]) => {
        this.dto = data;
        this.dataSource = new MatTableDataSource(this.dto);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    )
  }

  onSubmitSearch(form: FormGroup) {

    const dateRange = new DateRangeDto();
    dateRange.date = (form.value.dateTimeRange);

    this.loadAllSearchResults(dateRange,form.controls["mobileNo"].value);
  }

  loadAllSearchResults(date:DateRangeDto,mobileNo:string):void{
    const smsSearchParam = new smsSearchDTO();
    smsSearchParam.dateRangeDto = date;
    smsSearchParam.mobile = mobileNo;
    this.spinnerService.start();
    this.smsService.searchRequestDetails(smsSearchParam).subscribe(
      (data: SmsModel[]) => {
        this.dto = data;
        this.dataSource = new MatTableDataSource(this.dto);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },(error) => {
        this.spinnerService.stop();
        swal.fire('Sorry!', 'Something went wrong...!', 'error');
      },
      () => {
        this.spinnerService.stop();
        if (this.dto == null || this.dto.length === 0) {
          swal.fire('Sorry', 'No result found.', 'error');

        }
      }
    );
  }


  onClickReset() {
    this.requestForm.reset({
      dateTimeRange: [],
      mobileNo: null
    });
    this.loadAllRecords();
  }


  exportAsExcel() {
  this.spinnerService.start();
  this.smsService.exportAsExcel(this.dto).subscribe(
    (data:any)=>{
      const file = new Blob([data],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL,"_blank");
    },error => {
      this.spinnerService.stop();
      console.log(error);
    }
  );
  this.spinnerService.stop();
  }


  exportAsPDF() {
    this.spinnerService.start();
    this.smsService.exportAsPDF(this.dto).subscribe(
      (data:any) =>{
        console.log("This Data " + data);
        const file = new Blob([data], {type:'application/pdf'});
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL,"_blank");
      }, error => {
        this.spinnerService.stop();
        console.log(error);
      }
    );
    this.spinnerService.stop();
  }


  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }


}
